var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3A414C",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8 3.333v9.333M3.334 8h9.333"
})));
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.9dcd2e36.svg";